import { ChangeDetectorRef, Component, EventEmitter, Input, OnDestroy, Output, SimpleChanges } from '@angular/core';
import { DomSanitizer, SafeUrl } from '@angular/platform-browser';
import { firstValueFrom } from 'rxjs';
import { ProjectVersion } from 'src/app/constants/project-version-constans';
import { PaperSizeEnums } from 'src/app/enum/paper-size-enums';
import { EquipmentLogbookPrintModel } from 'src/app/models/archive/equipment-loogbook-print.model';
import { FormatDetailModel } from 'src/app/models/formats/format-detail.model';
import { FormatModel } from 'src/app/models/formats/format.model';
import { FormatDetailService } from 'src/app/services/formats/format-detail.service';
import { EnterpriseService } from 'src/app/services/management/enterprise.service';
import { PrintPageSizeService } from 'src/app/services/global-services/print-page-size.service';

interface GroupMetadata {
  branchCodeName: string;
  totalValueBranch: number
}

@Component({
  selector: 'app-print-equipment-logbook-valued',
  templateUrl: './print-equipment-logbook-valued.component.html',
  styleUrls: ['./print-equipment-logbook-valued.component.scss'],
  standalone: false
})
export class PrintEquipmentLogbookValuedComponent implements OnDestroy {

  @Input() companyId: number | null = 0;
  @Input() editFormat: boolean = false;
  @Input() equipmentLogbookPrintModel: EquipmentLogbookPrintModel = new EquipmentLogbookPrintModel();
  @Input() exportFormat: boolean = false;
  @Input() focusText: boolean = false;
  @Input() formatModel: FormatModel = new FormatModel();
  @Input() formatDetail: FormatDetailModel = new FormatDetailModel();
  @Input() printDocument: boolean = false;
  @Output() emitFormatDetail = new EventEmitter<FormatDetailModel>();
  @Output() finishLoadingPrintMaintenanceOrder = new EventEmitter<boolean>();

  columns: { field: string; header: string; }[] = [];
  idMap: { [key: string]: { id: string; type: string; showTotal: boolean; } } = {
    'index': { id: 'index', type: 'number', showTotal: false },
    'article': { id: 'articulo', type: 'text', showTotal: false },
    'detailRepair': { id: 'detalle-reparacion', type: 'text', showTotal: false },
    'quantity': { id: 'cantidad', type: 'decimal', showTotal: false },
    'unitCost': { id: 'costo-unitario', type: 'decimal', showTotal: false },
    'totalCost': { id: 'costo-total', type: 'decimal', showTotal: true }
  };
  groupDataMap: { [key: string]: GroupMetadata } = {};
  columnsTotals: { field: string; header: string; }[] = [];
  idMapTotals: { [key: string]: { id: string; type: string; showTotal: boolean; } } = {
    'conceptCode': { id: 'concepto-codigo', type: 'number', showTotal: false },
    'conceptName': { id: 'concepto-nombre', type: 'text', showTotal: false },
    'value': { id: 'valor-concepto', type: 'decimal', showTotal: true }
  };

  bottomPreview: number = 0;
  dateNow: Date = new Date();
  element: any;
  elementsBody: FormatDetailModel[] = [];
  elementsBodyTotals: FormatDetailModel[] = [];
  elementsLabel: FormatDetailModel[] = [];
  elementStyle: any;
  id = '';
  isShift = false;
  leftPreview: number = 0;
  listFormatDetailUpdates: FormatDetailModel[] = [];
  logoEnterprise: SafeUrl = "";
  mouseDown: boolean = false;
  newFormatDetail: FormatDetailModel = new FormatDetailModel();
  paperSize: number = PaperSizeEnums.letter;
  paperSizeFormat: number = 0;
  rightPreview: number = 0;
  shiftX: number = 0;
  shiftY: number = 0;
  speed = 2;
  topPreview: number = 0;
  version: string = ProjectVersion.projectVersion;

  private keydownListener!: (e: KeyboardEvent) => void;
  private mouseupListener!: () => void;
  private mousemoveListener!: (e: MouseEvent) => void;
  private keyupListener!: (e: KeyboardEvent) => void;

  constructor(private cdr: ChangeDetectorRef,
    private domSanitizer: DomSanitizer,
    private enterpriseService: EnterpriseService,
    private formatDetailService: FormatDetailService,
    private printPageSizeService: PrintPageSizeService) {
  }

  async ngOnChanges(changes: SimpleChanges): Promise<void> {
    const exportFormat = changes["exportFormat"];
    const formatModel = changes["formatModel"];
    const formatDetail = changes["formatDetail"];
    const equipmentLogbookPrintModel = changes["equipmentLogbookPrintModel"];

    if (exportFormat && !exportFormat.firstChange) { this.updateRangeFormatDetail(); }
    if (formatModel && formatModel.firstChange) { this.formatModel = formatModel.currentValue; }

    if (equipmentLogbookPrintModel && !equipmentLogbookPrintModel.firstChange) {
      await this.configureFormat();
      this.listFormatDetailUpdates = new Array<FormatDetailModel>();
    }
    if (formatDetail && !formatDetail.firstChange) { this.changeFormatDetail(); }
  }

  ngOnDestroy() {
    this.printPageSizeService.removePageSizeStyle();

    // Remover event listeners globales
    if (this.keydownListener) document.removeEventListener('keydown', this.keydownListener);
    if (this.mouseupListener) document.removeEventListener('mouseup', this.mouseupListener, true);
    if (this.mousemoveListener) document.removeEventListener('mousemove', this.mousemoveListener, true);
    if (this.keyupListener) document.removeEventListener('keyup', this.keyupListener);
  }

  ngAfterViewInit() {
    if (this.editFormat) {
      this.keydownListener = (e: KeyboardEvent) => {
        const target = e.target as HTMLElement;
        if (
          target &&
          (target.tagName === 'INPUT' ||
            target.tagName === 'TEXTAREA' ||
            target.tagName === 'SELECT' ||
            target.isContentEditable)
        ) {
          return;
        }
        // 2. Si no hay ningún elemento seleccionado para mover, no bloquear
        if (!this.element) {
          return;
        }

        // Deshabilita desplazamiento del scroll con la tecla espacio y flechas
        if (["Space", "ArrowUp", "ArrowDown", "ArrowLeft", "ArrowRight"].indexOf(e.code) > -1) {
          this.blockScrollArrows(e);
        }

        if (e.which == 16) this.isShift = true;
        //Mover element con flechas
        if (!this.isShift) {
          switch (e.key) {
            case 'ArrowLeft': { this.moveLeft(); break; }
            case 'ArrowRight': { this.moveRight(); break; }
            case 'ArrowUp': { this.moveUp(); break; }
            case 'ArrowDown': { this.moveDown(); break; }
          }
        }

        //Modificar element tamaño de objeto
        if (this.isShift) {
          switch (e.which) {
            case 37: { this.decreaseWidth(); break; }
            case 38: { this.decreaseHeight(); break; }
            case 39: { this.increaseWidth(); break; }
            case 40: { this.increaseHeight(); break; }
          }
        }
      };

      this.mouseupListener = () => {
        this.onMouseUp();
      };

      this.mousemoveListener = (e: MouseEvent) => {
        this.onMouseMove(e);
      };

      this.keyupListener = (e: KeyboardEvent) => {
        if (e.which == 16) this.isShift = false;
      };

      // Registrar los listeners en el document
      document.addEventListener('keydown', this.keydownListener);
      document.addEventListener('mouseup', this.mouseupListener, true);
      document.addEventListener('mousemove', this.mousemoveListener, true);
      document.addEventListener('keyup', this.keyupListener);
    }
  }

  private adjustElementSize(property: 'height' | 'width', delta: number) {
    if (this.focusText) return;

    const currentValue = this.elementStyle.getPropertyValue(property);
    const numericValue = parseFloat(currentValue.replace('px', ''));

    const newValue = numericValue + delta;
    this.element.style[property] = `${newValue}px`;

    this.onClick();
  }

  private async applyColumnStyles(equipmentLogbook: EquipmentLogbookPrintModel) {
    for (const column of this.columns.map(x => x.field)) {
      const element = this.elementsBody.find(x => x.description === column);
      if (!element) continue;
      equipmentLogbook.equipmentLogbookDetails.forEach(detail => {
        detail.maintenanceOrderByBranches.forEach(async maintenance => {
          this.element = document.getElementById(`${element.name}-${maintenance.maintenanceOrderId}`);
          if (this.element) {
            this.element.style.fontSize = `${element.fontSize}px`;
            this.element.style.width = `${element.width}%`;
            await this.changeAlignment(element.alignment);
          }
        });
      });
    }

    for (const column of this.columnsTotals.map(x => x.field)) {
      const element = this.elementsBodyTotals.find(x => x.description === column);
      if (!element) continue;
      this.element = document.getElementById(`${element.name}-${equipmentLogbook.equipmentLogbookId}`);
      if (this.element) {
        this.element.style.fontSize = `${element.fontSize}px`;
        this.element.style.width = `${element.width}%`;
        await this.changeAlignment(element.alignment);
      }
    }
  }

  private applyElementStyles(element: FormatDetailModel) {
    if (!element.visible) {
      this.element!.setAttribute('hidden', '');
      return;
    }

    const style = this.element!.style;
    style.fontSize = `${element.fontSize}px`;
    this.changeAlignment(element.alignment);
    this.changeBold(element.bold);
    this.changeBorder(element.border);

    if (element.name.includes('foot-') || element.name.includes('body-')) {
      style.height = `${element.height}px`;
      style.width = `${element.width}px`;
    } else if (element.name.includes('body-group-')) {
      style.backgroundColor = 'transparent';
      style.width = `${element.width}px`;
    } else {
      style.backgroundColor = 'transparent';
      style.position = 'absolute';
      style.left = `${element.left}%`;
      style.top = `${element.top}%`;
      style.height = `${element.height}px`;
      style.width = `${element.width}px`;
    }
  }

  private async applyFormatDetails(elements: FormatDetailModel[], equipmentLogbook: EquipmentLogbookPrintModel) {
    for (const element of elements) {
      if (element.band === 'body') continue;

      if (element.name.includes('body-group') || element.name.includes('foot-group')) {
        setTimeout(() => { this.groupingClasses(element); }, 200);
      } else {
        this.element = document.getElementById(`${element.name}-${equipmentLogbook.equipmentLogbookId}`);
        if (this.element) {
          this.applyElementStyles(element);
        }
      }
    }
  }

  private applyFormatStyles(element: HTMLElement) {
    element.style.fontSize = `${this.formatDetail.fontSize}px`;
    this.changeAlignment(this.formatDetail.alignment);
    this.changeBold(this.formatDetail.bold);
    this.changeBorder(this.formatDetail.border);

    if (!this.formatDetail.name.includes('foot-') && !this.formatDetail.name.includes('body-')) {
      element.style.position = 'absolute';
      element.style.left = `${this.formatDetail.left}%`;
      element.style.top = `${this.formatDetail.top}%`;
    }

    element.style.height = `${this.formatDetail.height}px`;
    element.style.width = `${this.formatDetail.width}px`;
  }

  private applyHeaderFooterHeights(equipmentLogbookId: number, formatModel: FormatModel) {
    const head = document.getElementById(`head-${equipmentLogbookId}`);
    const foot = document.getElementById(`foot-${equipmentLogbookId}`);
    head!.style.height = `${formatModel.head}px`;
    foot!.style.height = `${formatModel.foot}px`;
    this.paperSizeFormat = formatModel.paperSizeId
  }

  private applyParagraphStyles(equipmentLogbook: EquipmentLogbookPrintModel) {
    this.elementsBody
      .filter(x => x.type === 'p')
      .forEach(element => {
        equipmentLogbook.equipmentLogbookDetails.forEach(detail => {
          detail.maintenanceOrderByBranches.forEach(maintenance => {
            maintenance.equipmentLogbookRepairs.forEach(repair => {
              const id = element.name.includes("footer") ? maintenance.maintenanceOrderId : repair.repairId;
              this.element = document.getElementById(`${element.name}-${id}`);

              if (this.element) {
                this.element.style.fontSize = `${element.fontSize}px`;
                this.changeAlignment(element.alignment);
                this.changeBold(element.bold);
              }
            });
          });
        });
      });

    this.elementsBodyTotals
      .filter(x => x.type === 'p')
      .forEach(element => {
        equipmentLogbook.equipmentLogbookTotals.forEach(detail => {
          const id = element.name.includes("footer") ? equipmentLogbook.equipmentLogbookId : detail.conceptInvoicingId;
          this.element = document.getElementById(`${element.name}-${id}`);

          if (this.element) {
            this.element.style.fontSize = `${element.fontSize}px`;
            this.changeAlignment(element.alignment);
            this.changeBold(element.bold);
          }
        });
      });
  }

  blockScrollArrows(e: any) {
    if (!this.focusText) {
      e.preventDefault();
    }
  }

  private buildDisplayedColumns() {
    this.columns = [];
    this.elementsBody.filter(x => x.type === 'label' && x.orderTable !== null).forEach(element => {
      this.columns.push({ field: element.description!, header: element.text! });
    });

    this.columnsTotals = [];
    this.elementsBodyTotals.filter(x => x.type === 'label' && x.orderTable !== null).forEach(element => {
      this.columnsTotals.push({ field: element.description!, header: element.text! });
    });
  }

  async changeAlignment(alignment: string) {
    this.element.style.textAlign = alignment;
  }

  changeBold(bold: string) {
    this.element.style.fontWeight = bold;
  }

  changeBorder(border: string) {
    switch (border) {
      case 'noborder': {
        this.element.style.border = '0px none rgb(0, 0, 0)';
        break;
      }
      case 'border': {
        this.element.style.border = '1px solid rgb(0, 0, 0)';
        break;
      }
      case 'underline': {
        this.element.style.border = '0px none rgb(0, 0, 0)';
        this.element.style.borderBottom = '1px solid rgb(0, 0, 0)';
        break;
      }
    }
  }

  changeFormatDetail() {
    if (!this.equipmentLogbookPrintModel) return;
    const formatDetailId = this.formatDetail.formatDetailId;
    if (formatDetailId == 0) return;
    const isBody = this.formatDetail.band === 'body';
    const isBodyTotals = this.formatDetail.band === 'body-2';
    const isLabel = this.formatDetail.type === 'label';

    if (isBody) {
      const element = this.elementsBody.find(x => x.formatDetailId === formatDetailId);
      if (!element) return;

      element.alignment = this.formatDetail.alignment;
      element.fontSize = this.formatDetail.fontSize;

      if (isLabel) {
        element.visible = this.formatDetail.visible;
        element.width = this.formatDetail.width;
        element.text = this.formatDetail.text;

        if (!this.formatDetail.visible) {
          this.columns = this.columns.filter(x => x.field !== element.description);
        } else {
          this.equipmentLogbookPrintModel.equipmentLogbookDetails.forEach(detail => {
            detail.maintenanceOrderByBranches.forEach(maintenance => {
              if (this.element == null) {
                this.element = document.getElementById(`${this.formatDetail.name}-${maintenance.maintenanceOrderId}`);
              }
              this.updateElementWidth(this.formatDetail.name, maintenance.maintenanceOrderId!);
              this.updateElementStyle(this.formatDetail.name, maintenance.maintenanceOrderId);
              this.changeAlignment(this.formatDetail.alignment);
            });
          });
        }
      } else {
        element.bold = this.formatDetail.bold;
        this.equipmentLogbookPrintModel.equipmentLogbookDetails.forEach(detail => {
          detail.maintenanceOrderByBranches.forEach(maintenance => {
            maintenance.equipmentLogbookRepairs.forEach(repair => {
              if (this.element == null) {
                this.element = document.getElementById(`${this.formatDetail.name}-${repair.repairId}`);
              }
              this.updateElementStyle(this.formatDetail.name, repair.repairId);
              this.changeAlignment(this.formatDetail.alignment);
              this.changeBold(this.formatDetail.bold);
            })

          });
        });
      }
      this.elementsBody = this.elementsBody.filter(x => x.formatDetailId !== formatDetailId);
      this.elementsBody.push(element);
    } else if (isBodyTotals) { //AQUI VOY
      const element = this.elementsBodyTotals.find(x => x.formatDetailId === formatDetailId);
      if (!element) return;

      element.alignment = this.formatDetail.alignment;
      element.fontSize = this.formatDetail.fontSize;

      if (isLabel) {
        element.visible = this.formatDetail.visible;
        element.width = this.formatDetail.width;
        element.text = this.formatDetail.text;

        if (!this.formatDetail.visible) {
          this.columnsTotals = this.columnsTotals.filter(x => x.field !== element.description);
        } else {
          if (this.element == null) {
            this.element = document.getElementById(`${this.formatDetail.name}-${this.equipmentLogbookPrintModel.equipmentLogbookId}`);
          }
          this.updateElementWidth(this.formatDetail.name, this.equipmentLogbookPrintModel.equipmentLogbookId!);
          this.updateElementStyle(this.formatDetail.name, this.equipmentLogbookPrintModel.equipmentLogbookId);
          this.changeAlignment(this.formatDetail.alignment);
        }
      } else {
        element.bold = this.formatDetail.bold;
        this.equipmentLogbookPrintModel.equipmentLogbookTotals.forEach(detail => {
          if (this.element == null) {
            this.element = document.getElementById(`${this.formatDetail.name}-${detail.conceptInvoicingId}`);
          }

          this.updateElementStyle(this.formatDetail.name, detail.conceptInvoicingId);
          this.changeAlignment(this.formatDetail.alignment);
          this.changeBold(this.formatDetail.bold);
        });
      }
      this.elementsBodyTotals = this.elementsBodyTotals.filter(x => x.formatDetailId !== formatDetailId);
      this.elementsBodyTotals.push(element);
    }
    else {
      if (this.formatDetail.name.includes('body-group') || this.formatDetail.name.includes('foot-group')) {
        this.groupingClasses(this.formatDetail);

      } else {
        this.updateElementStyle(this.formatDetail.name, this.equipmentLogbookPrintModel.equipmentLogbookId);

        if (!this.formatDetail.visible) {
          if (this.element)
            this.element.setAttribute('hidden', '');
        } else {
          this.applyFormatStyles(this.element);
          this.updateLabelText(formatDetailId, this.formatDetail.text!);
          this.listFormatDetailUpdates = this.listFormatDetailUpdates.filter(x => x.formatDetailId !== formatDetailId);
          this.listFormatDetailUpdates.push(this.formatDetail);
        }
      }
    }
  }

  async chargeFormat(formatModel: FormatModel): Promise<boolean> {
    // eslint-disable-next-line no-async-promise-executor
    return new Promise(async (resolved) => {
      this.formatModel = formatModel;
      this.printPageSizeService.setPageSizeStyle(formatModel.paperSizeId);
      this.applyHeaderFooterHeights(this.equipmentLogbookPrintModel.equipmentLogbookId, formatModel);
      this.paperSizeFormat = formatModel.paperSizeId;

      this.extractFormatDetails(formatModel);
      this.buildDisplayedColumns();
      await this.applyFormatDetails(formatModel.formatDetails, this.equipmentLogbookPrintModel);

      setTimeout(async () => {
        await this.applyColumnStyles(this.equipmentLogbookPrintModel);
        this.applyParagraphStyles(this.equipmentLogbookPrintModel);
        resolved(true);
      }, 200);
    });
  }

  private extractFormatDetails(formatModel: FormatModel) {
    this.elementsLabel = formatModel.formatDetails.filter(x => x.type === 'label');
    this.elementsBody = formatModel.formatDetails.filter(x => x.band === 'body' && x.visible).sort((a, b) => a.orderTable - b.orderTable);
    this.elementsBodyTotals = formatModel.formatDetails.filter(x => x.band === 'body-2' && x.visible).sort((a, b) => a.orderTable - b.orderTable);
  }

  clickTable(event: any) {
    if (!this.editFormat) return;

    const element = document.getElementById(event.target.id);
    if (!element) return;

    const elementStyle = window.getComputedStyle(element);
    const name = event.target.id.substring(0, event.target.id.lastIndexOf('-'));
    const formatDetail = this.formatModel.formatDetails.find(x => x.name === name);
    const bodyElement = this.elementsBody.find(x => x.name === name);
    const bodyElementTotals = this.elementsBodyTotals.find(x => x.name === name);

    if (!formatDetail) return;

    this.newFormatDetail = new FormatDetailModel();
    this.newFormatDetail.name = name;
    this.newFormatDetail.formatDetailId = formatDetail.formatDetailId;
    this.newFormatDetail.formatId = this.formatModel.formatId;
    this.newFormatDetail.description = formatDetail.description;
    this.newFormatDetail.band = formatDetail.band;
    this.newFormatDetail.type = formatDetail.type;

    if (bodyElement) {
      this.newFormatDetail.visible = bodyElement.visible;
      this.newFormatDetail.text = bodyElement.text;
      this.newFormatDetail.orderTable = bodyElement.orderTable;
    }

    if (bodyElementTotals) {
      this.newFormatDetail.visible = bodyElementTotals.visible;
      this.newFormatDetail.text = bodyElementTotals.text;
      this.newFormatDetail.orderTable = bodyElementTotals.orderTable;
    }

    if (formatDetail.type === 'label') {
      const rawWidth = element.style.width;
      const width = parseFloat(rawWidth.replace('%', '')) || 0;
      this.newFormatDetail.width = parseFloat(width.toFixed(4));
    } else {
      this.newFormatDetail.width = 0;
    }

    const fontSize = parseInt(elementStyle.getPropertyValue('font-size').replace('px', ''));
    this.newFormatDetail.fontSize = isNaN(fontSize) ? 0 : fontSize;
    const fontWeight = elementStyle.getPropertyValue('font-weight');
    this.newFormatDetail.bold = fontWeight === '400' ? 'normal' : 'bold';
    this.newFormatDetail.alignment = elementStyle.getPropertyValue('text-align');

    this.emitFormatDetail.emit(this.newFormatDetail);
  }

  async configureFormat() {
    const logoElement = this.formatModel.formatDetails.find(x => x.name == 'logo');
    if (logoElement && logoElement.visible) {
      const enterpriseLogo = this.equipmentLogbookPrintModel.enterpriseLogo;
      if (enterpriseLogo == null) {
        this.getLogoDefault();
      } else {
        await this.getLogo(enterpriseLogo);
      }
    }

    const groupCounters = new Map<any, number>();
    const groupByColumn = 'maintenanceOrderConsecutive';

    this.equipmentLogbookPrintModel.equipmentLogbookDetails.forEach(detail => {
      detail.maintenanceOrderByBranches.forEach(maintenance => {
        const groupKey = maintenance[groupByColumn];
        maintenance.equipmentLogbookRepairs.forEach(repair => {
          if (!repair.article) {
            repair.index = null;
            return;
          }
          if (!groupCounters.has(groupKey)) {
            groupCounters.set(groupKey, 1);
          }

          repair.index = groupCounters.get(groupKey)!;
          groupCounters.set(groupKey, repair.index + 1);
        });
      });
    });

    try {
      const promises = this.processLogbookTotals(this.equipmentLogbookPrintModel);

      await Promise.all(promises);
      await this.chargeFormat(this.formatModel);
      this.cdr.detectChanges(); requestAnimationFrame(() => {
        this.finishLoadingPrintMaintenanceOrder.emit(true);
      });
    } catch (error) {
      console.error("Error en la configuración de nota:", error);
    }
  }

  private processLogbookTotals(equipmentLogbookPrintModel: EquipmentLogbookPrintModel): Promise<void>[] {
    const promises: Promise<void>[] = [];
    const conceptPromises = this.getGroupPromises(equipmentLogbookPrintModel);
    promises.push(...conceptPromises);
    return promises;
  }

  private getGroupPromises(equipmentLogbookPrintModel: EquipmentLogbookPrintModel): Promise<void>[] {
    const uniqueBranches = [...new Set(equipmentLogbookPrintModel.equipmentLogbookTotals.map(d => d.branchCode))];

    return uniqueBranches.map(async (branch) => {
      const groupItems = equipmentLogbookPrintModel.equipmentLogbookTotals.filter(d => d.branchCode === branch);
      const firstItem = groupItems[0];
      const totalValueGroup = groupItems.reduce((sum, item) => sum + (item.value || 0), 0);
      this.groupDataMap[`${equipmentLogbookPrintModel.equipmentLogbookId}_${branch}`] = {
        totalValueBranch: totalValueGroup,
        branchCodeName: `${firstItem.branchCode} - ${firstItem.branchName}`
      };
    });
  }

  decreaseHeight() {
    this.adjustElementSize('height', -this.speed);
  }

  decreaseWidth() {
    this.adjustElementSize('width', -this.speed);
  }

  onColumnReorder(columns: { field: string; header: string; }[]) {
    columns.forEach((col, index) => {
      this.elementsBody.find(x => x.description == col.field)!.orderTable = index;
    });
  }

  onColumnReorderTotals() {
    this.columnsTotals.forEach((col, index) => {
      this.elementsBodyTotals.find(x => x.description == col.field)!.orderTable = index;
    });
  }

  private getBorderStyle(): string {
    if (!this.elementStyle) return 'noborder';

    const sides = ['top', 'right', 'bottom', 'left'] as const;

    const hasBorder = (side: typeof sides[number]) => {
      const width = this.elementStyle.getPropertyValue(`border-${side}-width`);
      const style = this.elementStyle.getPropertyValue(`border-${side}-style`);
      return style !== 'none' && width !== '0px';
    };

    const borderStates = sides.map(side => hasBorder(side));
    const [top, right, bottom, left] = borderStates;

    if (top || right || left) {
      return 'border';
    } else if (bottom) {
      return 'underline';
    } else {
      return 'noborder';
    }
  }

  getGroupInfo(equipmentLogbookId: number, branchCode: number) {
    return this.groupDataMap[`${equipmentLogbookId}_${branchCode}`];
  }

  async getLogo(enterpriseLogo: string) {
    let blob: Blob | null = null;
    try {
      blob = await firstValueFrom(this.enterpriseService.getEnterpriseLogoAsync(enterpriseLogo));
      if (blob) {
        this.logoEnterprise = this.domSanitizer.bypassSecurityTrustUrl(URL.createObjectURL(blob));
      }
    } catch (error) {
      console.error('Error al obtener el logo de la empresa.', error);
    }
  }

  async getLogoDefault() {
    const logoPath = 'assets/images/icons/logo-empty.png';
    this.logoEnterprise = this.domSanitizer.bypassSecurityTrustUrl(logoPath);
  }


  private getStylePx(property: string): number {
    return parseFloat(this.elementStyle.getPropertyValue(property).replace('px', '')) || 0;
  }

  private getStylePxValue(property: string): number {
    const value = this.elementStyle.getPropertyValue(property);
    return parseFloat(value.replace('px', '')) || 0;
  }

  getTotal(field: string): number {
    const data = this.equipmentLogbookPrintModel.equipmentLogbookTotals;
    if (!data || data.length === 0) return 0;

    return data.reduce((sum, row) => {
      const value = (row as any)[field];
      return sum + (typeof value === 'number' ? value : 0);
    }, 0);
  }

  groupingClasses(element: FormatDetailModel) {
    let classEdit: any
    switch (element.name) {
      case "body-group-nombre-sucursal": {
        classEdit = document.querySelectorAll('.body-group-nombre-sucursal');
        this.setGroupingStyles(element, classEdit);
        break;
      }
      case "body-group-total-sucursal": {
        classEdit = document.querySelectorAll('.body-group-total-sucursal');
        this.setGroupingStyles(element, classEdit);
        break;
      }
      case "body-group-orden-mantenimiento": {
        classEdit = document.querySelectorAll('.body-group-orden-mantenimiento');
        this.setGroupingStyles(element, classEdit);
        break;
      }
      case "body-group-horometro-kms": {
        classEdit = document.querySelectorAll('.body-group-horometro-kms');
        this.setGroupingStyles(element, classEdit);
        break;
      }
      case "body-group-diagnostico-inicial": {
        classEdit = document.querySelectorAll('.body-group-diagnostico-inicial');
        this.setGroupingStyles(element, classEdit);
        break;
      }
      case "body-group-diagnostico-final": {
        classEdit = document.querySelectorAll('.body-group-diagnostico-final');
        this.setGroupingStyles(element, classEdit);
        break;
      }
      case "foot-group-branch": {
        classEdit = document.querySelectorAll('.foot-group-branch');
        this.setGroupingStyles(element, classEdit);
        break;
      }
      case "foot-group-total": {
        classEdit = document.querySelectorAll('.foot-group-total');
        this.setGroupingStyles(element, classEdit);
        break;
      }
    }
  }

  increaseHeight() {
    this.adjustElementSize('height', this.speed);
  }

  increaseWidth() {
    this.adjustElementSize('width', this.speed);
  }

  isGroup(index: any, item: any): boolean {
    return item.level;
  }

  // mmToPx(mm: number) {
  //   const inches = mm / 25.4;
  //   const px = inches * 101.654;
  //   return px;
  // }

  moveDown() {
    this.moveElement('top', this.speed, this.bottomPreview, true);
  }

  private moveElement(direction: 'top' | 'left', delta: number, previewLimit: number, isVertical: boolean) {
    if (this.focusText || !this.elementStyle) return;

    const currentValue = this.elementStyle.getPropertyValue(direction);
    let position = parseFloat(currentValue.replace('px', ''));

    position += delta;

    const sizeProp = isVertical ? 'height' : 'width';
    const size = parseFloat(this.elementStyle.getPropertyValue(sizeProp).replace('px', ''));

    if (position < 0) position = 0;
    if (position + size > previewLimit) position = previewLimit - size;

    const percentage = ((position / previewLimit) * 100).toFixed(4);
    this.element.style[direction] = `${percentage}%`;

    this.onClick();
  }

  moveLeft() {
    this.moveElement('left', -this.speed, this.rightPreview, false);
  }

  moveRight() {
    this.moveElement('left', this.speed, this.rightPreview, false);
  }

  moveUp() {
    this.moveElement('top', -this.speed, this.bottomPreview, true);
  }

  onClick() {
    if (!this.editFormat) return;

    const name = this.id.substring(0, this.id.lastIndexOf('-'));
    const formatDetail = this.formatModel.formatDetails.find(x => x.name === name);
    if (!formatDetail) return;

    this.newFormatDetail = new FormatDetailModel();
    this.newFormatDetail.name = name;
    this.newFormatDetail.formatDetailId = formatDetail.formatDetailId;
    this.newFormatDetail.formatId = this.formatModel.formatId;
    this.newFormatDetail.band = formatDetail.band;
    this.newFormatDetail.description = formatDetail.description;
    this.newFormatDetail.text = formatDetail.text;
    this.newFormatDetail.visible = true;

    this.newFormatDetail.fontSize = this.getStylePxValue('font-size');
    this.newFormatDetail.bold = this.elementStyle.getPropertyValue('font-weight') === '400' ? 'normal' : 'bold';
    this.newFormatDetail.alignment = this.elementStyle.getPropertyValue('text-align');
    this.newFormatDetail.border = this.getBorderStyle();

    if (!name.includes('foot-')) {
      this.newFormatDetail.left = parseFloat(((this.getStylePxValue('left') / this.rightPreview) * 100).toFixed(4));
      this.newFormatDetail.top = parseFloat(((this.getStylePxValue('top') / this.bottomPreview) * 100).toFixed(4));
    }

    if (!name.includes('body-group-')) {
      this.newFormatDetail.height = parseFloat(this.getStylePxValue('height').toFixed(4));
    }

    this.newFormatDetail.width = parseFloat(this.getStylePxValue('width').toFixed(4));
    this.newFormatDetail.height = parseFloat(this.getStylePxValue('height').toFixed(4));

    this.emitFormatDetail.emit(this.newFormatDetail);
    this.listFormatDetailUpdates = this.listFormatDetailUpdates.filter(x => x.formatDetailId !== this.newFormatDetail.formatDetailId);
    this.listFormatDetailUpdates.push(this.newFormatDetail);
  }

  onDragStart() {
    return false;
  }

  onMouseDown(event: any) {
    if (!this.editFormat) return;
    if (this.element) this.element.style.backgroundColor = 'transparent';

    this.mouseDown = true;
    this.id = event.target.id;
    this.element = document.getElementById(this.id);
    if (!this.element) return;

    this.elementStyle = window.getComputedStyle(this.element);
    this.element.style.backgroundColor = '#0d6efd6e';

    const name = this.id.substring(0, this.id.lastIndexOf('-'));
    const formatDetail = this.formatModel.formatDetails.find(x => x.name === name);
    if (!formatDetail) return;

    const relativeElement = document.getElementById(`${formatDetail.band}-${this.equipmentLogbookPrintModel.equipmentLogbookId}`);
    if (!relativeElement) return;

    const relativeStyle = window.getComputedStyle(relativeElement);

    this.leftPreview = Math.round(relativeElement.offsetLeft - relativeElement.scrollLeft);
    this.topPreview = Math.round(relativeElement.offsetTop - relativeElement.scrollTop);
    this.rightPreview = parseInt(relativeStyle.width.replace('px', ''));
    this.bottomPreview = parseInt(relativeStyle.height.replace('px', ''));

    if (!this.id.includes('foot-')) {
      this.element.style.cursor = 'move';

      const leftPX = event.pageX - this.leftPreview;
      const topPX = event.pageY - this.topPreview;

      this.shiftX = leftPX - this.getStylePx('left');
      this.shiftY = topPX - this.getStylePx('top');
    }

    this.onClick();
  }

  onMouseMove(event: any) {
    if (!this.mouseDown || this.id.includes('foot-') || this.id.includes('body-')) return;
    this.element.style.position = 'absolute';

    const leftPx = Math.max(0, event.pageX - this.leftPreview - this.shiftX);
    const widthPx = this.getStylePx('width');
    const finalLeft = Math.min(leftPx, this.rightPreview - widthPx);

    const topPx = Math.max(0, event.pageY - this.topPreview - this.shiftY);
    const heightPx = this.getStylePx('height');
    const finalTop = Math.min(topPx, this.bottomPreview - heightPx);

    this.updateElementPosition(finalLeft, finalTop);
    this.onClick();
  }

  onMouseUp() {
    this.mouseDown = false;
  }

  // pxToMm(px: number) {
  //   const inches = px / 101.654;
  //   const mm = inches * 25.4;
  //   return mm;
  // }

  async setGroupingStyles(element: FormatDetailModel, classEdit: any) {
    let border: string, borderBottom: string
    switch (element.border) {
      case 'noborder': {
        border = '0px none rgb(0, 0, 0)';
        borderBottom = '';
        break;
      }
      case 'border': {
        border = '1px solid rgb(0, 0, 0)';
        borderBottom = '';
        break;
      }
      case 'underline': {
        border = '0px none rgb(0, 0, 0)';
        borderBottom = '1px solid rgb(0, 0, 0)';
        break;
      }
    }

    classEdit.forEach((el: HTMLElement) => {
      el.style.backgroundColor = 'transparent';
      el.style.fontSize = `${element.fontSize}px`;
      el.style.textAlign = element.alignment;
      el.style.fontWeight = element.bold;
      el.style.border = border;
      el.style.borderBottom = borderBottom;
      el.style.height = element.name.includes('body-group-') ? 'auto' : `${element.height}px`;
      el.style.width = `${element.width}px`;
    });
  }

  private updateElementPosition(leftPx: number, topPx: number) {
    const leftPercentage = ((leftPx / this.rightPreview) * 100).toFixed(4);
    const topPercentage = ((topPx / this.bottomPreview) * 100).toFixed(4);

    this.element.style.left = `${leftPercentage}%`;
    this.element.style.top = `${topPercentage}%`;
  }

  private updateElementStyle(name: string, id: string | number) {
    this.element = document.getElementById(`${name}-${id}`);
    if (!this.element) return;

    this.element.style.fontSize = `${this.formatDetail.fontSize}px`;
  }

  private updateElementWidth(name: string, id: string | number) {
    this.element = document.getElementById(`${name}-${id}`);
    if (!this.element) return;
    this.element.style.width = `${this.formatDetail.width}%`;
  }

  private updateLabelText(formatId: number, text: string) {
    const labelElement = this.elementsLabel.find(x => x.formatDetailId === formatId);
    if (labelElement) {
      labelElement.text = text;
    }
  }

  async updateRangeFormatDetail() {
    this.elementsBody.forEach(element => {
      this.listFormatDetailUpdates.push(element);
    });

    this.elementsBodyTotals.forEach(element => {
      this.listFormatDetailUpdates.push(element);
    });

    const response = await firstValueFrom(this.formatDetailService.updateRangeFormatDetail(this.listFormatDetailUpdates));
    this.chargeFormat(response);
  }
}
